<template>
  <div class="content">
    <div class="title">基础设置</div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="小程序设置" name="mini"></el-tab-pane>
      <el-tab-pane label="推广设置" name="tgSet"></el-tab-pane>
      <el-tab-pane label="提现设置" name="third"></el-tab-pane>
      <el-tab-pane label="商户号设置" name="fourth"></el-tab-pane>
      <el-tab-pane label="其他设置" name="fou1rth"></el-tab-pane>
<!--      <el-tab-pane label="邀请海报" name="fou2rth"></el-tab-pane>-->
      <el-tab-pane label="快出退款设置" name="quickSet" v-if="soonRefund"/>
    </el-tabs>
    <!--    小程序设置-->
    <div class="top" v-if="!miniRelease.userVersion">
      <div class="top-text">
        <img src="@/assets/img/top_icon_news.png" alt="">
        <div class="text">正在部署发布小程序，预计1～2个工作日，请耐心等待，有疑问可以联系客服</div>
      </div>
    </div>
    <div class="center" v-if="activeIndex == 0">
      <div class="">
        <div class="center-title">
          <div class="bor"></div>
          基础信息
        </div>
        <div class="center-flex">
          <div class="center-text">小程序头像</div>
          <img class="image-header"
            :src="setFrom.appImg ? setFrom.appImg : require('@/assets/img/set_icon_head_default.png')" alt="">
        </div>
        <div class="center-flex">
          <div class="center-text">小程序名称</div>
          <div class="center-span">{{ setFrom.appName }}</div>
        </div>
        <div class="center-flex">
          <div class="center-text">套餐版本</div>
          <div class="center-span">{{ profitPackageSnapshot.name }}</div>
          <div class="center-button" @click="goActive">升级</div>
        </div>
        <div class="center-flex">
          <div class="center-text">授权时间</div>
          <div class="center-span">{{ setFrom.createTime }}</div>
        </div>
        <div class="center-flex">
          <div class="center-text">到期时间(基础套餐)</div>
          <div class="center-span" style="display: flex;align-items: center">
            {{ packageSnapshot.effectTime || '获取中...' }}
            <div class="center-button" @click="goActive">{{ getRestOfDay(packageSnapshot.effectTime) }}</div>
          </div>
        </div>
        <div class="center-flex" v-if="profitPackageSnapshot.effectTime">
          <div class="center-text">到期时间(分销套餐)</div>
          <div class="center-span" style="display: flex;align-items: center">
            {{ profitPackageSnapshot.effectTime || '获取中...' }}
            <div class="center-button" @click="goActive">{{ getRestOfDay(profitPackageSnapshot.effectTime) }}</div>
          </div>
        </div>
        <div class="center-flex">
          <div class="center-text">当前版本</div>
          <div class="center-span" v-if="miniRelease.userVersion != null">{{ miniRelease.userVersion }}</div>
        </div>
        <div class="center-flex">
          <div class="center-text">审核版本</div>
          <div class="center-span">{{ miniAudit.status == 0 ? '暂无' : miniAudit.userVersion }}</div>
        </div>
        <div class="center-flex">
          <div class="center-text">推广链接</div>
          <div class="center-span">pages/movie/movie</div>
          <div class="center-copy" v-clipboard:copy="promotionLink" v-clipboard:success="onCopy"
            v-clipboard:error="onError">复制
          </div>
        </div>
        <div class="center-bor"></div>
      </div>
      <div class="center-title">
        <div class="bor"></div>
        消息模版
        <div class="button" @click="synchronization()">同步消息模版</div>
      </div>
      <div class="center-flex" v-for="(item, index) in miniTemplateList" :key="index">
        <img
          :src="item.appTemplate ? require('@/assets/img/icon_checkbox_s.png') : require('@/assets/img/icon_cancel.png')"
          alt="">
        <div class="center-title">{{ item.remark }}</div>
      </div>
      <!--      <div class="center-flex">-->
      <!--        <img src="@/assets/img/icon_checkbox_s.png" alt="">-->
      <!--        <div class="center-title">出票消息通知</div>-->
      <!--      </div>-->
      <!--      <div class="center-flex">-->
      <!--        <img src="@/assets/img/icon_checkbox_s.png" alt="">-->
      <!--        <div class="center-title">订单关闭消息通知</div>-->
      <!--      </div>-->
      <!--      <div class="center-flex">-->
      <!--        <img src="@/assets/img/icon_cancel.png" alt="">-->
      <!--        <div class="center-title">退款消息通知</div>-->
      <!--      </div>-->
      <!--      <div class="center-flex">-->
      <!--        <img src="@/assets/img/icon_checkbox_s.png" alt="">-->
      <!--        <div class="center-title">影片开场前30分钟提醒</div>-->
      <!--      </div>-->
      <!--      <div class="button-save">保存</div>-->
    </div>
    <!--    推广设置-->
    <div class="center" v-if="activeIndex == 1">
      <div class="center-title">
        <div class="bor"></div>
        购票设置
      </div>
      <el-checkbox v-model="tgFrom.openDirect" :true-label="1" :false-label="0" label="特惠购票">特惠购票</el-checkbox>
<!--      <el-checkbox v-model="tgFrom.openCompete" :true-label="1" :false-label="0" label="竞价购票">竞价购票</el-checkbox>-->
      <el-checkbox v-model="tgFrom.openSoon" :true-label="1" :false-label="0" label="秒出票">秒出票</el-checkbox>
      <!--      <el-checkbox v-model="tgFrom.openTehuiSoon" :true-label="1" :false-label="0" fill="#FF8622" label="特惠秒出票">-->
      <!--        特惠秒出票-->
      <!--      </el-checkbox>-->
<!--      <div class="center-flex">-->
<!--        <div style="margin-right: 10px;">秒出票让利</div>-->
<!--        <input type="number" v-model="tgFrom.secondDiscount" class="input" placeholder="">-->
<!--        <div class="center-span">%</div>-->
<!--        <div class="center-input-span">-->
<!--          只可填写0~4之间（含）的整数，例：填写2%则表示将自己所得利益让给用户，用户购票为正常票价的98%，您获得的分润为2%-->
<!--        </div>-->
<!--      </div>-->
      <div v-if="profitPackageSnapshot.effectTime">
        <div class="center-bor"></div>
        <div class="center-title">
          <div class="bor"></div>
          分成设置
        </div>
        <div class="center-flex">
          <div class="center-input">一级代理分成</div>
          <input type="number" v-model="tgFrom.percentOne" class="input" placeholder="">
          <div class="center-span">%</div>
          <div class="center-input-span">设置20%表示：您的利润分佣*20%即为一级推广者所得</div>
        </div>
        <div class="center-flex">
          <div class="center-input">二级代理分成</div>
          <input type="number" v-model="tgFrom.percentTwo" class="input" placeholder="">
          <div class="center-span">%</div>
          <div class="center-input-span">设置20%表示：您的利润分佣*20%即二级推广者所得</div>
        </div>
        <div class="center-flex">
          <div class="center-input">总监提成</div>
          <input type="number" v-model="tgFrom.percentMajor" class="input" placeholder="">
          <div class="center-span">%</div>
          <div class="center-input-span">
            设置50%表示：您的利润分佣扣除一二级代理，剩下的50%为总监分红。扣除一二级佣金和总监分红即为您的平台最终利润。总监用户身份设置请到“<span @click="goUser"
              class="span-user">用户列表</span>”页面设置
          </div>
        </div>
      </div>
      <div class="form-title" style="margin-top: 40px">
        购票价折扣浮动设置
      </div>
      <div class="center-flex">
        <div style="margin-right: 10px;">特惠购票折扣浮动</div>
        <div class="input-wrap flex" style="margin-top: 0;margin-left: 10px">
          <input type="number" v-model="tgFrom.ticketDiscountFloat" class="input" placeholder="请输入-8~8之间的整数" style="width: 164px;">
          <div style="margin-left: 5px">%</div>
        </div>
        <div class="form-div-hint">
          例：某影票市场价100元，购买价90，则系统折扣为90%。您若设置折扣浮动3%，则购买价变为100x(90%+3%)=93元，设置成功后对所有影票生效。订单成交后，您的佣金=平台按溢价前的购买价结算给您佣金+您的溢价(100x3%)。
        </div>
      </div>
      <div class="center-flex">
        <div style="margin-right: 10px;">秒出票让利</div>
        <input type="number" v-model="tgFrom.secondDiscount" class="input" placeholder="">
        <div class="center-span">%</div>
        <div class="form-div-hint">
          只可填写0~4之间（含）的整数，例：填写2%则表示将自己所得利益让给用户，用户购票为正常票价的98%，您获得的分润为2%
        </div>
      </div>
      <div class="bottom" style="margin-top: 20px;">
        <div class="bottom-title"><img src="../../../../assets/img/set_icon_hint.png" alt="">温馨提示：</div>
        <div class="bottom-text">- 若您在投流期间，注重回本周期，可以适当提高定价；若希望提高成交率，可以适当降低定价。</div>
        <div class="bottom-text" style="color: #FF4F76">
          - 设置折扣浮动，不影响出票成功率和您的佣金结算。定价提高部分是您的专属佣金，平台不会额外抽取利润，也不会影响商家报价上限；同样，定价降低部分也将由你全部承担，结算时将从您的佣金中扣除。
        </div>
        <div class="bottom-text">- 价格浮动仅对特惠购票的售价生效，快出购票的售价不生效。</div>
      </div>
      <div class="custom-form-item">
        <div class="form-title-switch">
          <div class="form-title-switch-text">是否在选座页面总是显示加价后的价格</div>
          <el-switch class="form-title-switch-switch" v-model="tgFrom.virtualSeatMarkupSwitch" :active-value="1" :inactive-value="0"></el-switch>
          <div class="form-title-switch-desc">默认为关，开启后，无论有什么购票方式，选座页面都显示虚拟加价后的原价（=原分区市场价+虚拟加价）。</div>
        </div>
      </div>
    </div>
    <div class="center" v-if="activeIndex == 2">
      <div class="center-flex">
        <div class="center-input">最低提现金额</div>
        <input type="number" v-model="txFrom.withdrawMin" class="input" placeholder="">
        <div class="center-span">元</div>
        <div class="center-input-span">单笔提现大于最低提现金额才能提现，填写0则表示不限制</div>
      </div>
      <div class="center-flex">
        <div class="center-input">提现必须是</div>
        <input type="number" v-model="txFrom.withdrawPart" class="input" placeholder="">
        <div class="center-span">元的倍数</div>
        <div class="center-input-span">填写0则表示不限制</div>
      </div>
      <div class="center-flex">
        <div class="center-input">自动审核打款</div>
        <el-switch v-model="txFrom.isSwitch" :active-value="1" :inactive-value="0">
        </el-switch>
      </div>
      <div class="center-flex">
        <div class="center-input">审核打款开始时间</div>
        <input type="number" v-model="txFrom.startHour" class="input" placeholder="">

        <!--        <el-time-picker-->
        <!--          is-range-->
        <!--          v-model="time"-->
        <!--          range-separator="至"-->
        <!--          start-placeholder="开始时间"-->
        <!--          end-placeholder="结束时间"-->
        <!--          placeholder="选择时间范围"-->
        <!--        @change="getTime">-->
        <!--        </el-time-picker>-->
      </div>
      <div class="center-flex">
        <div class="center-input">审核打款结束时间</div>
        <input type="number" v-model="txFrom.endHour" class="input" placeholder="">
        <div class="center-input-span">设置后，在该时间段内，用户的提现申请将自动审核通过并打款。</div>
      </div>
      <div class="center-flex">
        <div class="center-input">打款方式</div>
        <div>平台官方打款</div>
        <!--        <el-radio v-model="txFrom.isSwitch" label="2" fill="#FF8622">自定义配置</el-radio>-->
        <!--        <div class="center-input-span">使用官方支付宝打款，打款成功将从账户余额</div>-->
      </div>
      <!--      <div class="center-flex">-->
      <!--        <div class="center-input">应用APPID</div>-->
      <!--        <input type="number" v-model="txFrom.appid" class="input" placeholder="">-->
      <!--      </div>-->
      <!--      <div class="center-flex">-->
      <!--        <div class="center-input" >支付宝公钥</div>-->
      <!--        <input type="number" v-model="txFrom.alipayPublicKey" class="input" placeholder="">-->
      <!--      </div>-->
      <!--      <div class="center-flex">-->
      <!--        <div class="center-input">应用私钥</div>-->
      <!--        <input type="number" v-model="txFrom.privateKey" class="input" placeholder="">-->
      <!--      </div>-->
      <!--      <div class="center-flex">-->
      <!--        <div class="center-input">应用私钥证书</div>-->
      <!--        <div class="center-upload">-->
      <!--          <el-upload-->
      <!--            class="upload-demo"-->
      <!--            :action="action"-->
      <!--            :data="uploadData"-->
      <!--            :on-remove="handleRemove"-->
      <!--            :on-success="upload"-->
      <!--            multiple-->
      <!--            :limit="3"-->
      <!--            :on-exceed="handleExceed"-->
      <!--            :file-list="fileList">-->
      <!--            <div class="upload-button"><img src="@/assets/img/icon_upload.png" alt="">点击上传</div>-->
      <!--          </el-upload>-->
      <!--          <div class="upload-text">只能上传crt格式和pem格式的文件,最多只能上传一个文件</div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="center-flex">-->
      <!--        <div class="center-input">支付宝公钥证书</div>-->
      <!--        <div class="center-upload">-->
      <!--          <el-upload-->
      <!--            class="upload-demo"-->
      <!--            :action="action"-->
      <!--            :data="uploadData"-->
      <!--            :on-remove="handleRemoveZfb"-->
      <!--            :on-success="uploadZfb"-->
      <!--            multiple-->
      <!--            :limit="3"-->
      <!--            :on-exceed="handleExceed"-->
      <!--            :file-list="fileList">-->
      <!--            <div class="upload-button"><img src="@/assets/img/icon_upload.png" alt="">点击上传</div>-->
      <!--          </el-upload>-->
      <!--          <div class="upload-text">只能上传crt格式和pem格式的文件,最多只能上传一个文件</div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="center-flex">-->
      <!--        <div class="center-input">支付宝CA证书</div>-->
      <!--        <div class="center-upload">-->
      <!--          <el-upload-->
      <!--            class="upload-demo"-->
      <!--            :action="action"-->
      <!--            :data="uploadData"-->
      <!--            :on-success="uploadCa"-->
      <!--            :on-remove="handleRemoveCa"-->
      <!--            multiple-->
      <!--            :limit="3"-->
      <!--            :on-exceed="handleExceed"-->
      <!--            :file-list="fileList">-->
      <!--            <div class="upload-button"><img src="@/assets/img/icon_upload.png" alt="">点击上传</div>-->
      <!--          </el-upload>-->
      <!--          <div class="upload-text">只能上传crt格式和pem格式的文件,最多只能上传一个文件</div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <!--    商户号设置-->
    <div class="center" v-if="activeIndex == 3">
      <div class="center-flex">
        <div class="center-input"><span>*</span>微信商户号ID</div>
        <input type="number" v-model="shhFrom.merchantId" class="input" placeholder="请输入">
      </div>
      <div class="center-flex">
        <div class="center-input"><span>*</span>微信密钥key</div>
        <input type="text" v-model="shhFrom.merchantKey" class="input" placeholder="请输入">
      </div>
      <div class="center-flex">
        <div class="center-input"><span>*</span>apiclient_cert.pem路径</div>
        <div class="center-upload">
          <el-upload class="upload-demo" :action="actionShh" :on-success="uploadSuccess" :on-remove="handleRemoveShh"
            multiple :limit="3" :on-exceed="handleExceed" :file-list="fileListShh">
            <div class="upload-button"><img src="@/assets/img/icon_upload.png" alt="">点击上传</div>
          </el-upload>
        </div>
      </div>
      <div class="center-flex">
        <div class="center-input"><span>*</span>apiclient_key.pem路径</div>
        <div class="center-upload">
          <el-upload class="upload-demo" :action="actionShh" :on-remove="handleRemoveSy" :on-success="uploadSuccessSy"
            :data="uploadData" multiple :limit="3" :on-exceed="handleExceed" :file-list="fileListSy">
            <div class="upload-button"><img src="@/assets/img/icon_upload.png" alt="">点击上传</div>
          </el-upload>
        </div>
      </div>
      <div class="center-flex">
        <div class="center-input"><span>*</span>apiclient_key.12路径</div>
        <div class="center-upload">
          <el-upload class="upload-demo" :action="actionShh" :on-remove="handleRemove12" :on-success="uploadSuccess12"
            :data="uploadData" multiple :limit="3" :on-exceed="handleExceed" :file-list="fileList12">
            <div class="upload-button"><img src="@/assets/img/icon_upload.png" alt="">点击上传</div>
          </el-upload>
        </div>
      </div>
      <!--      <div class="center-flex">-->
      <!--        <div class="center-input">支付授权目录</div>-->
      <!--        <div class="center-span">www.baidu.com</div>-->
      <!--        <div class="center-copy"-->
      <!--             v-clipboard:copy="promotionLink"-->
      <!--             v-clipboard:success="onCopy"-->
      <!--             v-clipboard:error="onError">复制</div>-->
      <!--        <div class="center-input-span">请将此链接复制黏贴进微信支付授权目录，</div>-->
      <!--      </div>-->
    </div>
    <!--    其他设置-->
    <div class="center" v-if="activeIndex == 4">
      <div class="center-title">
        <div class="bor"></div>
        客服设置<span class="text">自营客服为微信小程序客服，需在微信后台设置服务客服，为了保证客服质量，高峰期建议开启自营客服</span>
      </div>
      <div class="center-flex">
        <div class="center-input">客服接入方式</div>
        <el-radio-group v-model="otherFrom.serviceType">
          <el-radio :label="1">守兔平台客服</el-radio>
          <el-radio :label="2">微信官方客服</el-radio>
          <el-radio :label="3">自定义客服</el-radio>
        </el-radio-group>
      </div>
      <div class="center-service" v-if="otherFrom.serviceType == 3">
        <div class="center-service-title">客服微信二维码</div>
        <el-upload :action="actionPoster" :data="uploadDataCode" :headers="headers" :file-list="fileListServiceUrl"
          list-type="picture-card" :on-success="uploadSuccessService" :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove" :limit="1">
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </div>
<!--      <div class="center-title" style="margin-top: 50px">-->
<!--        <div class="bor"></div>-->
<!--        转发设置<span class="text" style="width: 600px;">是否可通过小程序右上角转发按钮进行转发，如不可转发，则小程序只能通过邀请海报进行转发(<span-->
<!--            style="color: red">注：开通分销后，通过邀请海报进行转发才可绑定关系，首页小程序右上角转发则无法绑定上下级关系</span>)</span>-->
<!--      </div>-->
<!--      <div class="center-flex">-->
<!--        <div class="center-input">是否可转发</div>-->
<!--        <el-radio-group v-model="otherFrom.openTranspond">-->
<!--          <el-radio :label="0">可转发</el-radio>-->
<!--          <el-radio :label="1">不可转发</el-radio>-->
<!--        </el-radio-group>-->
<!--      </div>-->
      <div class="center-title" style="margin-top: 50px">
        <div class="bor"></div>
        关注公众号设置<span class="text">开启后，首页会显示关注公众号提醒，引导用户关注公众号</span>
      </div>
      <div class="center-flex">
        <div class="center-input"></div>
        <el-radio-group v-model="otherFrom.gzhTipOpen">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </div>
      <div class="official-item">
        <div class="official-item-text">提示文案</div>
        <input v-model="otherFrom.gzhDesc" placeholder="请输入"></input>
      </div>
      <div class="official-item">
        <div class="official-item-text">公众号文章链接</div>
        <input v-model="otherFrom.gzhLink" placeholder="请输入"></input>
        <div class="official-item-span"><span style="color: red">请使用手机微信打开</span>需要推广的公众号的文章，点击右上角
          ’···‘ 复制文章链接，填入左侧输入框。用户进入此文章中完成公众号的关注。
        </div>
      </div>

      <div class="center-title" style="margin-top: 50px">
        <div class="bor"></div>
        小程序首页版式设置<span class="text">(仅支持微信小程序)</span>
      </div>
      <div class="center-flex">
        <div class="center-input"></div>
        <el-radio-group v-model="otherFrom.indexFormat">
          <el-radio :label="0">竖版样式<span class="text-view" @click="handleView(0)">预览</span></el-radio>
          <el-radio :label="1">横版样式<span class="text-view" @click="handleView(1)">预览</span></el-radio>
        </el-radio-group>
      </div>
      <el-image style="position: absolute;bottom: 10000px" :src="url" ref="previewImg" :preview-src-list="Array(url)">
      </el-image>
    </div>
    <!--    邀请海报-->
<!--    <div class="center" v-if="activeIndex == 5">-->
<!--      <el-upload class="upload-demo" :action="actionPoster" :on-preview="handlePreview" :on-remove="handleRemove"-->
<!--        :before-remove="beforeRemove" :data="uploadData" :headers="headers" multiple :limit="3" :on-exceed="handleExceed"-->
<!--        :on-success="handleSuccess" :file-list="fileList">-->
<!--        <div class="center-add">添加自定义海报</div>-->
<!--      </el-upload>-->
<!--      <div class="center-title" style="margin-top: 27px">-->
<!--        <div class="bor"></div>-->
<!--        系统海报-->
<!--      </div>-->
<!--      <div class="center-image">-->
<!--        <div class="image-item" v-for="(item, index) in poster.shoutoPosterList" :key="index">-->
<!--          <img :src="item.image" alt="">-->
<!--          &lt;!&ndash;          <div class="image-item-radio" @click="changeStatus(item,1)">&ndash;&gt;-->
<!--          &lt;!&ndash;            <img :src="item.status?selectIcon:unselectIcon" alt="">&ndash;&gt;-->
<!--          &lt;!&ndash;            <span>启用</span>&ndash;&gt;-->
<!--          &lt;!&ndash;          </div>&ndash;&gt;-->
<!--          <div style="text-align: center">-->
<!--            <el-checkbox v-model="item.state" :true-label="1" :false-label="0" @change="changeStatus($event, item, 1)">-->
<!--              启用-->
<!--            </el-checkbox>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="center-title" style="margin-top: 27px">-->
<!--        <div class="bor">-->
<!--        </div>-->
<!--        自定义海报-->
<!--      </div>-->
<!--      <div class="center-image">-->
<!--        <div class="image-item" v-for="(item, index) in poster.selfPosterList" :key="index">-->
<!--          <img :src="item.image" alt="">-->
<!--          <div class="center-flex">-->
<!--            <div class="image-item-radio" style="margin-right: 16px" @click="deletePoster(item, 1)">-->
<!--              <img src="@/assets/img/set_icon_delete_s.png" alt="">-->
<!--              <span class="delete">删除</span>-->
<!--            </div>-->
<!--            &lt;!&ndash;            <div class="image-item-radio" @click="changeStatus(item,2)">&ndash;&gt;-->
<!--            &lt;!&ndash;              <img :src="item.status?selectIcon:unselectIcon" alt="" >&ndash;&gt;-->
<!--            &lt;!&ndash;              <span>启用</span>&ndash;&gt;-->
<!--            &lt;!&ndash;            </div>&ndash;&gt;-->
<!--            <div style="text-align: center">-->
<!--              <el-checkbox v-model="item.state" @change="changeStatus($event, item, 2)" :true-label="1" :false-label="0">-->
<!--                启用-->
<!--              </el-checkbox>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="center-title" style="margin-top: 27px">-->
<!--        <div class="bor">-->
<!--        </div>-->
<!--        已启用-->
<!--      </div>-->
<!--      <div class="center-image" style="margin-bottom: 20px">-->
<!--        <div class="image-item" v-for="(item, index) in poster.startPosterVos">-->
<!--          <img :src="item.image" alt="">-->
<!--          <div class="center-flex">-->
<!--            <div class="image-item-radio" style="margin-right: 16px" @click="deletePoster(item, 2)">-->
<!--              <img src="@/assets/img/set_icon_delete_s.png" alt="">-->
<!--              <span class="delete">删除</span>-->
<!--            </div>-->
<!--            &lt;!&ndash;            <div class="image-item-radio" @click="changeStatus(item,3)">&ndash;&gt;-->
<!--            &lt;!&ndash;              <img :src="item.status?selectIcon:unselectIcon" alt="">&ndash;&gt;-->
<!--            &lt;!&ndash;              <span>启用</span>&ndash;&gt;-->
<!--            &lt;!&ndash;            </div>&ndash;&gt;-->
<!--            &lt;!&ndash;              <el-checkbox v-model="item.status" :true-label="1" :false-label="0" @change="changeStatus($event,item,3)">启用</el-checkbox>&ndash;&gt;-->
<!--            <div class="image-item-radio" @click="sortCurPoster(item)">-->
<!--              <img src="@/assets/img/set_icon_litre_s.png" alt="">-->
<!--              <span class="up">升序</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="save" v-if="![0,5].includes(Number(activeIndex))">
      <div class="save-button" @click="save">保存</div>
    </div>
    <!--    快出退款设置-->
    <div class="center" v-if="activeIndex == 5 && soonRefund">
      <quick-set type="zfb"></quick-set>
    </div>
    <el-dialog title="提示" :visible.sync="dialogShow" width="30%" :before-close="handleClose">
      <div class="dialog">
        <div class="dialog-text">确定删除海报？</div>
        <div class="dialog-button">
          <div class="button-cancel" @click="dialogShow = false">取消</div>
          <div class="button-success" @click="confirm()">确定</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import selectBtn from '@/assets/img/official/set_btn_iselected_2.png'
import unselectBtn from '@/assets/img/official/set_btn_nochoice_1.png'
import mini from "@/api/mini";
import { matchInteger } from "@/utils/regExp";
import QuickSet from "@/views/pc/miniProgram/set/quickSet.vue";


const MiniModel = new mini()
export default {
  name: "index",
  components: {QuickSet},
  data() {
    return {
      soonRefund: 0,
      selectIcon: selectBtn,
      unselectIcon: unselectBtn,
      activeName: 'mini',
      actionShh: process.env.VUE_APP_NEW_OPEN_URL + '/movie/open/upload/merchant',
      action: process.env.VUE_APP_NEW_OPEN_URL + '/movie/open/params_withdraw/upload-local',
      actionPoster: process.env.VUE_APP_NEW_OPEN_URL + '/movie/open/params_post/upload-self-poster',
      uploadData: {
        appKey: localStorage.getItem('appKeyMini'),
      },
      uploadDataCode: {
        appKey: localStorage.getItem('appKeyMini'),
        imageType: 2 // 表明是二维码
      },
      activeIndex: 0,
      checkList: ['特惠购票'],
      value: false,
      time: '',
      radio: '',
      fileListShh: [],
      fileListSy: [],
      fileList12: [],
      fileList: [],
      tgFrom: {
        openCompete: 0,
        openDirect: 0,
        openSoon: 0,
        openTehuiSoon: 0,
        percentMajor: '',
        percentOne: '',
        percentTwo: '',
        secondDiscount: '',
        appKey: localStorage.getItem('appKeyMini'),
        ticketDiscountFloat: '',
        virtualSeatMarkupSwitch:0,
      },
      txFrom: {
        appKey: localStorage.getItem('appKeyMini'),
        alipayPublicKey: '',
        alipayType: '',
        appCert: '',
        appid: '',
        certKeyRsa: '',
        endHour: '',
        isSwitch: '',
        privateKey: '',
        rootCert: '',
        startHour: '',
        withdrawMin: '',
        withdrawPart: ''
      },
      posterFrom: {
        appKey: localStorage.getItem('appKeyMini'),
        posterIds: [],
        posterUrls: [],
        selfPosterIds: []
      },
      poster: {},
      dialogShow: false,
      selfPosterId: '',
      setFrom: {},
      shhFrom: {},
      otherFrom: {
        gzhDesc: ''
      },
      packageSnapshot: {},
      profitPackageSnapshot: {},
      miniRelease: {},
      miniAudit: {},
      miniTemplateList: {},
      promotionLink: 'pages/movie/movie',
      isUpload: true,
      headers: {
        OPENTOKEN: localStorage.getItem('java-open-token')
      },
      dialogImageUrl: '',
      dialogVisible: false,
      fileListServiceUrl: [],
      deleteType: 0,
      url: 'https://yingpiao.oss-cn-shenzhen.aliyuncs.com/mini-img/indexOld.jpg',
      showImage: false
    }
  },
  mounted() {
    this.getSet()
  },
  methods: {
    handleClick(e) {
      console.log(e.index,'e.index')
      this.activeIndex = e.index
      this.getSet()
      // if (e.index != 5) {
      //   this.getSet()
      // } else {
      //   if (this.isUpload) {
      //     this.getSet()
      //     this.isUpload = false
      //   }
      // }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handleRemoveZfb(file, fileList) {
      console.log(file, fileList);
    },
    handleRemoveCa(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleClose() {
      this.dialogShow = false
    },
    // 复制订单信息
    onCopy() {
      this.$message.success('复制成功！')
    },
    onError() {
      this.$message.success('复制失败！')
    },
    handleSuccess(response, file, fileList) {
      this.poster.selfPosterList.push({ image: response.data.url, state: 0, id: response.data.id })
    },
    getSet() {
      let params = {
        appKey: this.tgFrom.appKey
      }
      if (this.activeIndex == 0) {
        MiniModel.setMini(params).then(res => {
          if (res.data.code == 200) {
            this.setFrom = res.data.data
            this.packageSnapshot = res.data.data.packageSnapshot || {}
            this.soonRefund = res.data.data.soonRefund
            this.profitPackageSnapshot = res.data.data.profitPackageSnapshot || {}
            this.miniRelease = res.data.data.miniRelease || {}
            this.miniAudit = res.data.data.miniAudit || {}
            this.miniTemplateList = res.data.data.miniTemplateList || {}
          } else {
            this.$message.error(res.data.info)
          }
        })
      }
      if (this.activeIndex == 1) {
        MiniModel.setTgMiniSearch(params).then(res => {
          if (res.data.code == 200) {
            this.tgFrom = res.data.data
          } else {
            this.$message.error(res.data.info)
          }
        })
      }
      if (this.activeIndex == 2) {
        MiniModel.setTxMiniSearch(params).then(res => {
          if (res.data.code == 200) {
            this.txFrom = res.data.data
          } else {
            this.$message.error(res.data.info)
          }
        })
      }
      if (this.activeIndex == 3) {
        MiniModel.getMiniShh(params).then(res => {
          if (res.data.code == 200) {
            this.shhFrom = res.data.data
            // this.fileListShh = this.shhFrom.
            console.log('res.data.data.mchP', res.data.data.mchP)
            if (res.data.data.mchP != '' && this.fileList12.length == 0) {
              var obj = {
                name: res.data.data.mchP,
                url: res.data.data.mchP
              }
              this.fileList12.push(obj)
            }
            if (res.data.data.mchCert != '' && this.fileListShh.length == 0) {
              var objShh = {
                name: res.data.data.mchCert,
                url: res.data.data.mchCert
              }
              this.fileListShh.push(objShh)
            }
            if (res.data.data.mchCert != '' && this.fileListSy.length == 0) {
              var objSy = {
                name: res.data.data.mchKey,
                url: res.data.data.mchKey
              }
              this.fileListSy.push(objSy)
            }
          } else {
            this.$message.error(res.data.info)
          }
        })
      }
      if (this.activeIndex == 4) {
        MiniModel.otherSettings(params).then(res => {
          if (res.data.code == 200) {
            this.otherFrom = res.data.data
            if (res.data.data.serviceUrl != '' && this.fileListServiceUrl.length == 0) {
              var obj = {
                name: res.data.data.serviceUrl,
                url: res.data.data.serviceUrl
              }
              this.fileListServiceUrl.push(obj)
            }
          } else {
            this.$message.error(res.data.info)
          }
        })
      }
      // if (this.activeIndex == 5 && this.isUpload) {
      //   this.posterFrom = {
      //     posterUrls: [],
      //     posterIds: [],
      //     selfPosterIds: [],
      //     appKey: localStorage.getItem('appKeyMini'),
      //   }
      //   MiniModel.setPosterMiniSearch(params).then(res => {
      //     if (res.data.code == 200) {
      //       this.poster = res.data.data
      //       for (let index in this.poster.startPosterVos) {
      //         this.posterFrom.posterUrls.push(this.poster.startPosterVos[index].image)
      //         this.posterFrom.posterIds.push(this.poster.startPosterVos[index].id)
      //         if (this.poster.startPosterVos[index].type == 1) {
      //           this.posterFrom.selfPosterIds.push(this.poster.startPosterVos[index].id)
      //         }
      //       }
      //       console.log(this.posterFrom)
      //     } else {
      //       this.$message.error(res.data.info)
      //     }
      //   })
      // }
    },
    // 保存
    save() {
      console.log(this.activeIndex, 'this.activeIndex')
      // 推广设置
      if (this.activeIndex == 1) {
        if (this.tgFrom.ticketDiscountFloat === '' && this.promotionForm.ticketDiscountFloat != 0) {
          this.$message.error('请输入折扣')
          return
        }
        if (this.tgFrom.ticketDiscountFloat > 8 || this.tgFrom.ticketDiscountFloat < -8) {
          this.$message.error('折扣浮动只能输入-8~8之间的整数')
          return;
        }
        if (this.tgFrom.ticketDiscountFloat.toString().indexOf('.') != -1) {
          this.$message.error('折扣浮动请输入整数')
          return;
        }
        if (!matchInteger.test(this.tgFrom.secondDiscount)) {
          this.$message.error('秒出票让利请输入正整数')
          return
        }
        if (this.tgFrom.secondDiscount > 4 || this.tgFrom.secondDiscount < 0) {
          this.$message.error('秒出票让利请输入0~4之间（含）的整数')
          return
        }
        MiniModel.setTgMini(this.tgFrom).then(res => {
          if (res.data.code == 200) {
            this.$message.success('保存成功')
          } else {
            this.$message.error(res.data.info)
          }
        })
      }
      //提现设置
      if (this.activeIndex == 2) {
        console.log('this.txFrom', this.txFrom)
        this.txFrom.appKey = localStorage.getItem('appKeyMini')
        MiniModel.setTxMini(this.txFrom).then(res => {
          if (res.data.code == 200) {
            this.$message.success('保存成功')
          } else {
            this.$message.error(res.data.info)
          }
        })
      }
      //商户号设置
      if (this.activeIndex == 3 && this.shhFrom.type == 1) {
        MiniModel.editMiniShh(this.shhFrom).then(res => {
          if (res.data.code == 200) {
            this.$message.success('保存成功')
          } else {
            this.$message.error(res.data.info)
          }
        })
      }
      if (this.activeIndex == 3 && this.shhFrom.type == 0) {
        this.$message.success('使用的是守兔官方商户号，请联系客服修改')
        return;
      }
      //其他设置
      if (this.activeIndex == 4) {
        console.log('otherFrom', this.otherFrom)
        this.otherFrom.appKey = localStorage.getItem('appKeyMini')
        if (this.otherFrom.gzhTipOpen === 1 && this.otherFrom.gzhDesc === '') {
          this.$message.error('请输入公众号描述')
          return
        }
        if (this.otherFrom.gzhTipOpen === 1 && this.otherFrom.gzhLink === '') {
          this.$message.error('请输入公众号链接')
          return
        }
        MiniModel.saveOtherSettings(this.otherFrom).then(res => {
          if (res.data.code == 200) {
            this.$message.success('保存成功')
          } else {
            this.$message.error(res.data.info)
          }
        })
      }
      // if (this.activeIndex == 5) {
      //   // 转格式
      //   console.log(this.posterFrom)
      //   console.log('this.posterFrom', this.posterFrom)
      //   MiniModel.upadtePoster(this.posterFrom).then(res => {
      //     if (res.data.code == 200) {
      //       this.activeIndex = 5
      //       this.isUpload = true
      //       this.getSet()
      //       this.$message.success('保存成功')
      //     } else {
      //       this.$message.error(res.data.info)
      //     }
      //   })
      // }
      let that = this
      setTimeout(() => {
        that.getSet()
      }, 2000)
    },
    upload(res) {
      console.log(res)
    },
    uploadZfb(res) {
      console.log(res)
    },
    uploadCa(res) {
      console.log(res)
    },
    getTime(e) {
      this.txFrom.startHour = e[0]
      this.txFrom.endHour = e[1]
    },
    changeStatus(e, item, index) {
      console.log(e)
      console.log(index === 1 && e == 1)
      if (index === 1 && e == 1) {
        let arr = this.posterFrom.posterIds
        let imageList = this.posterFrom.posterIds
        console.log('arr.length', arr.length)
        if (arr.length == 0) {
          this.posterFrom.posterIds.push(item.id)
          this.posterFrom.posterUrls.push(item.image)
        } else {
          // 循环处理已选中
          for (let index in arr) {
            console.log('arr[index]', arr[index])
            if (arr[index] == item.id) {
              return
            } else {
              this.posterFrom.posterIds.push(item.id)
            }
            if (imageList[index] == item.image) {
              return
            } else {
              this.posterFrom.posterUrls.push(item.image)
            }
            break
          }
        }
      } else {
        // 循环处理筛选出已启用图片和id
        let list = this.posterFrom.posterUrls
        let idList = this.posterFrom.posterIds
        let idSelfList = this.posterFrom.selfPosterIds
        // 系统海报的url
        for (let index in list) {
          console.log(list[index])
          console.log(item.image)
          if (list[index] == item.image) {
            list.splice(index, 1)
            this.posterFrom.posterUrls = list
          }
          break
        }
        // 系统海报也要传id
        console.log("debug:________________idList______________", idList);
        for (let index in idList) {
          console.log(idList[index])
          console.log(item.id)
          if (idList[index] == item.id) {
            idList.splice(index, 1)
            this.posterFrom.posterIds = idList
            break
          }
        }
        // 处理自定义海报id 系统海报只要传id
        for (let index in idSelfList) {
          console.log(idSelfList[index])
          console.log(item.id)
          if (idSelfList[index] == item.id) {
            idSelfList.splice(index, 1)
            this.posterFrom.selfPosterIds = idSelfList
          }
          break
        }
      }
      console.log(e)
      if (index === 2 && e == 1) {
        console.log('this.posterFrom.selfPosterId', this.posterFrom.selfPosterIds)
        this.posterFrom.selfPosterIds.push(item.id)
      }
      console.log(index)
      // if(index === 3 && e){
      //
      // }
    },
    deletePoster(item, type) {
      this.deleteType = type
      this.dialogShow = true
      this.selfPosterId = item.id
      // 循环处理筛选出已启用图片和id
      let list = this.posterFrom.posterUrls
      let idList = this.posterFrom.posterIds
      let idSelfList = this.posterFrom.selfPosterIds
      for (let index in list) {
        console.log(list[index] == item.image)
        if (list[index] == item.image) {
          list.splice(index, 1)
          this.posterFrom.posterUrls = list
        }
      }
      for (let index in idList) {
        console.log(idList[index] == item.id)
        if (idList[index] == item.id) {
          idList.splice(index, 1)
          this.posterFrom.posterIds = idList
        }
      }
      console.log('idSelfList', idSelfList)
      // 处理自定义海报id 系统海报只要传id
      for (let index in idSelfList) {
        console.log(idSelfList[index])
        console.log(item.id)
        if (idSelfList[index] == item.id) {
          idSelfList.splice(index, 1)
          this.posterFrom.selfPosterIds = idSelfList
        }
      }
    },
    confirm() {
      if (this.deleteType == 2) {
        console.log("debug:________________this.posterFrom______________", this.posterFrom);
        MiniModel.upadtePoster(this.posterFrom).then(res => {
          if (res.data.code == 200) {
            this.$message.success('删除成功')
            this.dialogShow = false
            this.activeIndex = 5
            this.isUpload = true
            this.getSet()
          } else {
            this.$message.error(res.data.info)
          }
        })
      } else {
        const params = {
          selfPosterId: this.selfPosterId,
          appKey: localStorage.getItem('appKeyMini')
        }
        MiniModel.deletePoster(params).then(res => {
          console.log("debug:________________res______________", res);
          if (res.data.code == 200) {
            this.$message.success('删除成功')
            this.dialogShow = false
            this.activeIndex = 5
            this.isUpload = true
            this.getSet()
          } else {
            this.$message.error(res.data.info)
          }
        })
      }
    },
    // 升序
    sortCurPoster(item) {
      let i
      let tempIndex = -1
      for (i = 0; i < this.poster.startPosterVos.length; i++) {
        if (this.poster.startPosterVos[i].type == item.type && this.poster.startPosterVos[i].id == item.id) {
          tempIndex = i
          break
        }
      }
      if (tempIndex > 0) {
        let tempPosterItem = this.poster.startPosterVos[tempIndex - 1]
        this.poster.startPosterVos.splice(tempIndex - 1, 1, item)
        this.poster.startPosterVos.splice(tempIndex, 1, tempPosterItem)
      }
      let imageList = [] // 图片数组
      let idList = [] // id数组
      // 循环处理图片
      for (let index in this.poster.startPosterVos) {
        imageList.push(this.poster.startPosterVos[index].image)
        idList.push(this.poster.startPosterVos[index].id)
      }
      // 赋值到图片from表单
      this.posterFrom.posterUrls = imageList
      this.posterFrom.posterIds = idList
    },
    // 节流函数
    throttle(fn, delay) {
      let timer = null
      return function () {
        if (!timer) {
          timer = setTimeout(() => {
            fn.apply(this, arguments)
            timer = null
          }, delay)
        }
      }
    },
    // 同步模版消息
    synchronization() {
      this.throttle(this.getMessage, 1000)();
    },
    getMessage() {
      let param = {
        appKey: localStorage.getItem('appKeyMini')
      }
      MiniModel.miniMessage(param).then(res => {
        if (res.data.code == 200) {
          this.$message.success('同步成功')
        } else {
          this.$message.error(res.data.info)
        }
      })
    },
    handleRemoveSy(file, fileList) {
      console.log(file, fileList);
    },
    // 上传成功钩子
    uploadSuccess(response) {
      console.log('response', response)
      this.shhFrom.mchCert = response.data
    },
    // 上传成功钩子私钥
    uploadSuccessSy(response) {
      console.log('response', response)
      this.shhFrom.mchKey = response.data
    },
    handleRemove12(file, fileList) {
      console.log(file, fileList);
    },
    handleRemoveShh(file, fileList) {
      console.log(file, fileList);
    },
    // 上传成功钩子
    uploadSuccess12(response) {
      console.log('response', response)
      this.shhFrom.mchP12 = response.data
    },
    goActive() {
      this.$router.push('/pc/zfbMiniProgram/activate')
    },
    // 获取剩余天数
    getRestOfDay(createTime) {
      let _d_tm = new Date(new Date().valueOf());
      let _d_now = new Date(new Date().valueOf());
      if (createTime) {
        _d_now = new Date((createTime).replace(/-/g, "/"));
      }
      if (_d_now < _d_tm) {
        return '已过期'
      }
      if (_d_now > _d_tm) {
        return '续费'
      }
      // let leftTime =  ~~((_d_now - _d_tm) / 1000 / 60 / 60 / 24);
      // return  leftTime+'天'

    },
    handleRemoveImage(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    uploadSuccessService(response) {
      this.otherFrom.serviceUrl = response.data.url
    },
    handleView(type) {
      let url = ''
      if (type === 0) {
        url = 'https://yingpiao.oss-cn-shenzhen.aliyuncs.com/mini-img/indexOld.jpg'
      } else {
        url = 'https://yingpiao.oss-cn-shenzhen.aliyuncs.com/mini-img/indexNew.jpg'
      }
      this.url = url
      this.$refs.previewImg.showViewer = true
    },
    // 跳转到用户列表
    goUser() {
      this.$router.push('/pc/zfbMiniProgram/user')
    }
  }
}
</script>

<style scoped lang="less">
.content {
  width: 100%;
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  position: relative;

  .title {
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 25px;
  }

  .center {
    padding: 30px;
    margin-bottom: 30px;

    .center-title {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 22px;
      margin-bottom: 10px;

      .text {
        font-size: 12px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #999999;
        line-height: 17px;
        margin-left: 10px;
      }

      .bor {
        width: 2px;
        height: 14px;
        background: #FF8622;
        margin-right: 8px;
      }

      .button {
        font-size: 12px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 28px;
        width: 96px;
        height: 28px;
        background: #FF8622;
        border-radius: 2px;
        text-align: center;
        margin-left: 20px;
        cursor: pointer;
      }
    }

    .center-add {
      width: 120px;
      height: 32px;
      background: #FF8622;
      border-radius: 2px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }

    .center-image {
      height: 283px;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #EEEEEE;
      padding: 20px;
      margin-top: 15px;
      display: flex;
      overflow-x: scroll;

      .image-item {
        margin-right: 20px;
        width: 120px;
        height: 213px;

        img {
          width: 120px;
          height: 213px;
        }

        .image-item-radio {
          text-align: center;

          img {
            width: 20px;
            height: 20px;
          }
        }
      }
    }

    .center-flex {
      display: flex;
      align-items: center;
      margin-top: 20px;

      .center-title {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #666666;
        line-height: 20px;
        margin-left: 8px;
      }

      .center-text {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #999999;
        line-height: 20px;
        margin-right: 30px;
        width: 70px;
        text-align: right;
      }

      .image-header {
        width: 40px;
        height: 40px;
        border-radius: 100%;
      }

      .center-span {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #333333;
        line-height: 20px;
      }

      .center-input {
        width: 160px;
        text-align: right;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #666666;
        line-height: 20px;
        margin-right: 20px;

        span {
          color: #FF4F76;
        }
      }

      .center-input-span {
        font-size: 12px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #999999;
        line-height: 17px;
        margin-left: 7px;
        width: 500px;
      }

      .center-copy {
        width: 56px;
        height: 24px;
        background: #F5F5FA;
        border-radius: 2px;
        font-size: 12px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #999999;
        line-height: 24px;
        text-align: center;
        margin-left: 10px;
        cursor: pointer;
      }

      .center-button {
        width: 56px;
        height: 24px;
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #FF8622;
        text-align: center;
        font-size: 12px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FF8622;
        line-height: 24px;
        margin-left: 10px;
        cursor: pointer;
      }
    }

    .center-bor {
      height: 1px;
      border: 1px solid #EEEEEE;
      margin-top: 40px;
      margin-bottom: 30px;
    }
  }
}

.button-save {
  width: 108px;
  height: 36px;
  background: #FF8622;
  border-radius: 2px;
  margin-top: 40px;
  text-align: center;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 36px;
  cursor: pointer;
}

.input {
  width: 160px;
  height: 36px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #EEEEEE;
  padding: 0 10px;
}

.save {
  height: 64px;
  background: #FFFFFF;
  box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  position: fixed;
  bottom: 0;
  right: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  //width: 73%;
  //left: 299px;
  .save-button {
    width: 108px;
    height: 36px;
    background: #FF8622;
    border-radius: 2px;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
  }
}

.upload-button {
  width: 112px;
  height: 36px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #3D9EFC;
  text-align: center;
  line-height: 36px;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #3D9EFC;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.upload-text {
  font-size: 12px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #999999;
  line-height: 17px;
}

.delete {
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FF5178;
  line-height: 20px;
  cursor: pointer;
}

.dialog {
  padding: 20px 80px;

  .dialog-title {
    font-size: 16px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 24px;
  }

  .dialog-text {
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 24px;
    margin-top: 8px;
    text-align: center;
  }

  .dialog-button {
    display: flex;
    align-items: center;
    margin-top: 48px;
    justify-content: center;

    .button-success {
      width: 76px;
      height: 32px;
      background: #FF8622;
      border-radius: 2px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }

    .button-cancel {
      width: 76px;
      height: 32px;
      border-radius: 2px;
      border: 1px solid #EEEEEE;
      margin-right: 10px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }
  }
}

.up {
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FF8622;
  line-height: 20px;
  cursor: pointer;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.top {
  height: 40px;
  background: #FFF6F8;
  border-radius: 4px;
  border: 1px solid #FFCAD5;
  width: 100%;
  margin-bottom: 10px;

  .top-text {
    height: 40px;
    display: flex;
    align-items: center;
    margin-left: 16px;

    .text {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
      line-height: 20px;
      margin-left: 8px;

      span {
        color: #FF4F76;
      }
    }
  }
}

.form-title {
  font-size: 16px;
  color: #222222;
  text-align: left;
  font-family: Alibaba-PuHuiTi-M;
  font-weight: 500;
  border-left: 2px solid #ff8622;
  padding-left: 10px;
  margin-bottom: 20px;
  line-height: 15px;
}

.form-div {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 20px;
}

.form-div {
  font-size: 14px;
}

.flex {
  display: flex;
  align-items: center;
}

.form-div-hint {
  font-size: 12px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #999999;
  line-height: 17px;
  margin-left: 10px;
  width: 60%;
}

.bottom {
  background: #FAFAFA;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 20px;
}

.bottom-title {
  font-size: 12px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FF4F76;
  line-height: 17px;
  display: flex;
  align-items: center;
}

.bottom-title img {
  width: 20px;
  height: 20px;
}

.bottom-text {
  font-size: 12px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #999999;
  line-height: 17px;
  margin-left: 20px;
}

.form-div-text {
  width: 58px;
}

.center-service {
  margin-left: 77px;
  margin-top: 20px;
  display: flex;

  .center-service-title {
    margin-right: 20px;
  }
}

.official-item {
  display: flex;
  align-items: center;
  margin-top: 20px;

  .official-item-text {
    width: 100px;
    text-align: right;
    marigin-right: 20px;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 20px;
  }

  .official-item-span {
    font-size: 12px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    line-height: 20px;
    margin-left: 10px;
    width: 50%;
  }

  input {
    width: 360px;
    height: 36px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #EEEEEE;
    padding: 0 10px;
    margin-left: 20px
  }
}

.text-view {
  color: #3D9EFC !important;
  cursor: pointer;
  margin-left: 20px;
  font-size: 12px;
}

.span-user {
  color: #3D9EFC;
  text-decoration: underline;
  cursor: pointer;
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #EEEEEE;
}

/deep/ .el-tabs__item.is-active {
  color: #FF8622 !important;
}

/deep/ .el-tabs__active-bar {
  background-color: #FF8622 !important;
}

/deep/ .el-tabs__item:hover {
  color: #FF8622 !important;
}

/deep/ .el-table th,
.el-table tr {
  background-color: #FCFAF8;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #FF8622 !important;
  border-color: #FF8622 !important;
}

/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #FF8622 !important;
}

/deep/ .el-checkbox__inner:hover {
  border-color: #FF8622 !important;
}

/deep/ .el-radio__input.is-checked+.el-radio__label {
  color: #FF8622 !important;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  background-color: #FF8622 !important;
  border-color: #FF8622 !important;
}

/deep/ .el-tabs__nav-wrap::after {
  height: 1px !important;
}

/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ input[type="number"] {
  -moz-appearance: textfield;
}

/deep/.el-icon-circle-close:before {
  color: #fff
}
.custom-form-item{
  margin-top: 40px;
  .form-title-switch{
    border-left: 2px solid #ff8622;
    padding-left: 10px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    .form-title-switch-text{
      min-width: 160px;
      font-size: 16px;
      line-height: 15px;
      color: #222222;
      text-align: left;
      font-family: Alibaba-PuHuiTi-M;
      font-weight: 500;
    }

    .form-title-switch-switch{
      margin-left: 40px;
    }

    .form-title-switch-desc{
      color: #999;
      font-size: 14px;
      font-weight: 400;
      margin-left: 20px;
    }

  }
  .add-price-content{
    display: flex;
    flex-direction: column;

    .add-price-btn{
      width: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .add-price-item{
      display: flex;
      flex-direction: row;
      margin-bottom: 20px;

      .add-price-item-index{
        display: flex;
        align-items: center;
        width: 30px;
      }

      .add-price-item-title{
        display: flex;
        align-items: center;
        word-break: keep-all;
      }

      .add-price-item-select{
        display: flex;
        flex-direction: row;
      }

      .add-price-item-value{
        display: flex;
        flex-direction: row;
        margin-left: 20px;
      }

      .add-price-item-del{
        margin-left: 20px;
        width: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .no-discounts-img{
    width: 400px;
    height: 400px;
    img{
      height: 100%;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/zfbMiniProgram/set/index.vue